import { Selector } from "@ngrx/store";

interface AppState {
    loadingStatus: number;
}

export const isLoading: Selector<AppState, boolean> = (state: AppState) => state.loadingStatus > 0;
